module.exports = __webpack_public_path__ + "static/phone-1c-1aee2988413a3c318b6a9fd17dd383eb.svg";